/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packing_List_Col_CartonsInputs */

const en_packing_list_col_cartons = /** @type {(inputs: Packing_List_Col_CartonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartons`)
};

/**
* | output |
* | --- |
* | "Cartons" |
*
* @param {Packing_List_Col_CartonsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const packing_list_col_cartons = /** @type {((inputs?: Packing_List_Col_CartonsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packing_List_Col_CartonsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_packing_list_col_cartons(inputs)
});